import React from 'react';

import LoadingOverlay from 'components/LoadingOverlay';
import { Step } from 'components/SteppedModal';
import { BlueskyPostModalSteps } from '../types';

const useAuthenticationProgressStep = (): Step<BlueskyPostModalSteps> => {
  return {
    id: 'authentication-in-progress',
    title: 'Authenticating with Bluesky',
    fluidFooterButtons: true,
    hideFooter: true,
    component: <LoadingOverlay small />,
  };
};

export default useAuthenticationProgressStep;
